import React from 'react';
import AsyncLoading from '@components/AsyncLoading';

const CircularIndex = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'CircularIndex' */ './components/CircularIndex'
		)
);

export default (store) => {
	return {
		index: true,
		element: <AsyncLoading component={<CircularIndex />} />,
	};
};
